import { uuid } from "@xapp/chat-widget-core";
import { ChatState } from "../ChatState";
import { createDefaultState, DEFAULT_STATE } from "../DefaultState";

export function resetReducer(state: ChatState = DEFAULT_STATE): ChatState {
    const defaultState = createDefaultState({
        accessToken: state.accessToken,
        userId: state.userId,
        attributes: state.attributes,
        sessionExpiration: state.sessionExpiration
    });

    // If we have an active connection, preserve status to avoid showing offline during reconnect
    const wasOnline = state.connection.connectionStatus === 'online';

    // Preserve opened state so widget doesn't close on refresh
    const wasOpened = state.visuals?.opened;

    return {
        // Start with fresh default state (clears messages, resets everything)
        ...defaultState,
        connection: {
            ...defaultState.connection,
            greetingRequested: false,
            // Generate new nonce to trigger server recreation and start fresh session
            nonce: uuid(),
            // Preserve connection status during transition if we were online
            connectionStatus: wasOnline ? 'online' : defaultState.connection.connectionStatus
        },
        // Preserve accountStatus if we were online to avoid showing offline message during reconnect
        accountStatus: wasOnline ? 'online' : defaultState.accountStatus,
        visitor: state.visitor,
        visitorId: state.visitorId,
        // Reset visuals but preserve opened state so widget stays open during refresh
        visuals: {
            opened: wasOpened,
            hasInteracted: false
        }
    };
}
